import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import UsersList from './Users/List';
import CreateUser from './Users/Create';
import NotFound from './Errors/NotFound';
import EditContainer from '../components/EditContainer';
import AgenciesList from './Agencies/List';
import CreateAgencies from './Agencies/Create';

class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/admin/users" component={UsersList} />
        <Route exact path="/admin/users/new" component={CreateUser} />
        <Route exact path="/admin/users/:id" component={EditContainer} />

        <Route exact path="/admin/agenzie" component={AgenciesList} />
        <Route exact path="/admin/agenzie/new" component={CreateAgencies} />
        <Route exact path="/admin/agenzie/:id" component={EditContainer} />
         {/* <Route exact path="/admin/users/:id/password" component={ChangeUserPassword} /> */}
        <Route component={NotFound} />
      </Switch>
    );
  }
}

export default Routes;
